// Thin wrapper over the existing PostHog analytics already loaded in index.html.
// Never pass personal or project data here.
export function track(event: string, props?: Record<string, unknown>) {
  try {
    const ph = (window as unknown as { posthog?: { capture?: (e: string, p?: Record<string, unknown>) => void } }).posthog;
    ph?.capture?.(event, props ?? {});
  } catch {
    /* analytics must never break the app */
  }
}
